<template>
    <div class="convention">
        <Form :model="formItem" :label-width="100">
            <FormItem :label="$t('convention.service_url1')">
                <Input v-model="formItem.kefu_url"></Input>
            </FormItem>
            <!-- <FormItem label="客服链接2">
                <Input v-model="formItem.input"></Input>
            </FormItem>-->
            <FormItem :label="$t('convention.siteTitle')">
                <Input v-model="formItem.web_title"></Input>
            </FormItem>
            <FormItem :label="$t('convention.model')">
                <RadioGroup v-model="formItem.mode">
                    <Radio :label="$t('convention.model1')">{{$t('convention.model1')}}</Radio>
                    <Radio :label="$t('convention.model2')">{{$t('convention.model2')}}</Radio>
                </RadioGroup>
            </FormItem>
<!--             <FormItem :label="$t('convention.middleVipPrice')">
                <Input v-model="formItem.vip1_price"></Input>
            </FormItem>
            <FormItem :label="$t('convention.advancedVipPrice')">
                <Input v-model="formItem.vip2_price"></Input>
            </FormItem> -->
            <!-- <FormItem label="关闭提示">
                <Input
                    v-model="formItem.textarea"
                    type="textarea"
                    :autosize="{minRows: 2,maxRows: 5}"
                ></Input>
            </FormItem>-->
            <FormItem :label="$t('convention.indexBanner')">
                <div class="file_bar">
                    <div class="file_box">
                        <img
                            class="id_img"
                            :src="$ht_ip + formItem.banner1"
                            v-show="formItem.banner1"
                            alt
                        />
                        <div class="img" v-show="!formItem.banner1">
                            <p class="gray_color">{{$t('selectPhoto')}}</p>
                        </div>
                        <input type="file" accept="image/*" @change="get_file($event,1)" />
                        <div
                            class="show_big_img"
                            @click="big_img = formItem.banner1;show_big_img = true"
                        >{{$t('viewBigPotho')}}</div>
                    </div>
                    <div class="file_box">
                        <img
                            class="id_img"
                            :src="$ht_ip + formItem.banner2"
                            v-show="formItem.banner2"
                            alt
                        />
                        <div class="img" v-show="!formItem.banner2">
                            <p class="gray_color">{{$t('selectPhoto')}}</p>
                        </div>
                        <input type="file" accept="image/*" @change="get_file($event,2)" />
                        <div
                            class="show_big_img"
                            @click="big_img = formItem.banner2;show_big_img = true"
                        >{{$t('viewBigPotho')}}</div>
                    </div>
                </div>
            </FormItem>
            <FormItem :label="$t('convention.selectBanner')">
                <RadioGroup v-model="formItem.banner_selection">
                    <Radio label="1">1</Radio>
                    <Radio label="2">2</Radio>
                </RadioGroup>
            </FormItem>
              <FormItem :label="$t('seal')">
                <div class="file_bar">
                    <div class="file_box">
                        <img
                            class="id_img"
                            :src="$ht_ip + formItem.seal"
                            v-show="formItem.seal"
                            alt
                        />
                        <div class="img" v-show="!formItem.seal">
                            <p class="gray_color">{{$t('selectPhoto')}}</p>
                        </div>
                        <input type="file" accept="image/*" @change="get_file($event,3)" />

                    </div>
                </div>
            </FormItem>          
            <FormItem>
                <Button type="primary" @click="doPost">{{$t('submit')}}</Button>
                <Button style="margin-left: 8px">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>
        <Modal v-model="show_big_img" :title="$t('viewBigPhoto')" width="600" @on-ok="big_img = ''">
            <img class="big_img" :src="big_img" alt />
        </Modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            formItem: {},
            banner: "",
            img_load: false,
            big_img: "",
            show_big_img: false
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        doPost() {
            this.$post(this.$path.system, this.formItem).then(res => {
                if (res.success) {
                    this.$Message.success(this.$i18n.t('operateSuccess'));
                } else {
                    this.$Message.error(this.$i18n.t('operateFailed'));
                }
            });
        },
        loadData() {
            this.$get(this.$path.system, {}).then(res => {
                if (res.data) {
                    this.formItem = res.data;
                    this.formItem.banner_selection =
                        this.formItem.banner_selection + "";
                } else {
                    this.$Message.error(his.$i18n.t('dataFailed'));
                }
            });
        },
        get_file(e, index) {
            this.img_load = true;
            let formData = new FormData();
            formData.append("img", e.currentTarget.files[0]);
            this.$file(this.$path.upload, formData)
                .then(res => {
                    this.img_load = false;
                    if (index == 1) {
                        this.formItem.banner1 = res.data.path;
                    } else if(index==2) {
                        this.formItem.banner2 = res.data.path;
                    }else{
                        this.formItem.seal = res.data.path
                    }
                })
                .catch(err => {
                    this.img_load = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped>
.top,
.bottom {
    text-align: center;
}
.file_bar {
    display: flex;
    flex-direction: row;
    .file_box {
        display: flex;
        flex-direction: column;
        width: 200px;
        height: 170px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        border: 1px #eeeeee dashed;
        border-radius: 4px;
        margin-right: 20px;
        .show_big_img {
            width: 100%;
            height: 20px;
            cursor: pointer;
            text-align: center;
        }
        img {
            width: 100%;
            height: 150px;
        }
        .img {
            width: 100%;
            height: 100%;

            p {
                text-align: center;
                color: #bab9b9;
                margin-top: 50px;
            }
        }
        input {
            position: absolute;
            top: 0;
            left: 0;
            width: 200px;
            height: 150px;
            opacity: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/system/convention.vue